import { getLLMModels } from "../../../../graphql/queries";
import { API } from 'aws-amplify';


export const PROMPT_CONSTANTS = {
  MAX_INSTRUCTIONS_LENGTH: 3000,
  MAX_DESCRIPTION_LENGTH: 180,
  EXISTING_PROMPT_NAMES: ["My prompt", "Your prompt"],
};

export const fetchLLMModels = async () => {
  try {
    const response = await API.graphql({
      query: getLLMModels,
      authMode: "AMAZON_COGNITO_USER_POOLS",
    });
    return JSON.parse(response.data.getLLMModels.body)["OpenAI"];
  } catch (error) {
    return []
  }
}

export const MOCK_AGENTS = [
  { id: 1, avatar: "https://i.pravatar.cc/300", name: "Finance Agent", avatarSize: "md" },
  { id: 2, avatar: "https://i.pravatar.cc/300", name: "Marketing Agent", avatarSize: "md" },
  { id: 3, avatar: "https://i.pravatar.cc/300", name: "Support Agent", avatarSize: "md" },
  { id: 4, avatar: "https://i.pravatar.cc/300", name: "Operations Agent", avatarSize: "md" },
  { id: 5, avatar: "https://i.pravatar.cc/300", name: "Sales Agent", avatarSize: "md" },
  { id: 6, avatar: "https://i.pravatar.cc/300", name: "Finance Agent", avatarSize: "md" },
  { id: 7, avatar: "https://i.pravatar.cc/300", name: "Marketing Agent", avatarSize: "md" },
  { id: 8, avatar: "https://i.pravatar.cc/300", name: "Support Agent", avatarSize: "md" },
  { id: 9, avatar: "https://i.pravatar.cc/300", name: "Operations Agent", avatarSize: "md" },
  { id: 10, avatar: "https://i.pravatar.cc/300", name: "Sales Agent", avatarSize: "md" },
  { id: 11, avatar: "https://i.pravatar.cc/300", name: "Finance Agent", avatarSize: "md" },
  { id: 12, avatar: "https://i.pravatar.cc/300", name: "Marketing Agent", avatarSize: "md" },
  { id: 13, avatar: "https://i.pravatar.cc/300", name: "Support Agent", avatarSize: "md" },
  { id: 14, avatar: "https://i.pravatar.cc/300", name: "Operations Agent", avatarSize: "md" },
  { id: 15, avatar: "https://i.pravatar.cc/300", name: "Sales Agent", avatarSize: "md" },
  { id: 16, avatar: "https://i.pravatar.cc/300", name: "Finance Agent", avatarSize: "md" },
  { id: 17, avatar: "https://i.pravatar.cc/300", name: "Marketing Agent", avatarSize: "md" },
  { id: 18, avatar: "https://i.pravatar.cc/300", name: "Support Agent", avatarSize: "md" },
  { id: 19, avatar: "https://i.pravatar.cc/300", name: "Operations Agent", avatarSize: "md" },
  { id: 20, avatar: "https://i.pravatar.cc/300", name: "Sales Agent", avatarSize: "md" },
  { id: 21, avatar: "https://i.pravatar.cc/300", name: "Finance Agent", avatarSize: "md" },
  { id: 22, avatar: "https://i.pravatar.cc/300", name: "Marketing Agent", avatarSize: "md" },
  { id: 23, avatar: "https://i.pravatar.cc/300", name: "Support Agent", avatarSize: "md" },
  { id: 24, avatar: "https://i.pravatar.cc/300", name: "Operations Agent", avatarSize: "md" }
]; 

export const CATEGORIES = [
  { label: "Sales", value: "sales" },
  { label: "Marketing", value: "marketing" },
  { label: "Customer Support", value: "customer_support" },
  { label: "Finance", value: "finance" },
  { label: "Human Resources (HR)", value: "human_resources" },
  { label: "Operations", value: "operations" },
  { label: "IT & Security", value: "it_security" },
  { label: "Legal & Compliance", value: "legal_compliance" },
  { label: "Product & Engineering", value: "product_engineering" },
  { label: "Executive & Strategy", value: "executive_strategy" },
  { label: "Training & Enablement", value: "training_enablement" },
  {label: "Product & Vendor Management",value: "product_vendor_management"},
  { label: "Inventory & Logistics", value: "inventory_logistics" },
  { label: "Data & Analytics", value: "data_analytics" },
  { label: "Internal Communications", value: "internal_communications" },
];
